import {createAction, createReducer} from 'redux-act'
import { selector as configSelector } from '~/config'
import { select, apply, put, call, takeEvery, all } from 'redux-saga/effects'

import { Entity, handleError } from '~/utils/entity-utils'

import API from '~/api'
import {get} from "lodash";

const entityName = 'discount';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = {
  ...entity.actions,
  enable: {
    request: createAction('enable discount request', (id) => ({id})),
    failure: createAction('enable discount failure', (message, error) => ({message, error})),
    success: createAction('enable discount success', (discount) => ({discount}))
  },
  disable: {
    request: createAction('disable discount request', (id) => ({id})),
    failure: createAction('disable discount failure', (message, error) => ({message, error})),
    success: createAction('disable discount success', (discount) => ({discount}))
  },
};

// WORKERS
export const workers = {
  ...entity.workers,
  * enableDiscount(action, throwError=true) {
    const { id } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const route = `discounts/${id}/enable/`;
      const response = yield apply(api, api.callRoute, [route, 'POST']);

      yield put(actions.enable.success(response.data));

      return response.data;
    } catch (e) {
      yield call(handleError, e, actions.enable);
      if(throwError) {
        throw e;
      }
    }
  },
  * disableDiscount(action, throwError=true) {
    const { id } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const route = `discounts/${id}/disable/`;
      const response = yield apply(api, api.callRoute, [route, 'POST']);

      yield put(actions.enable.success(response.data));

      return response.data;
    } catch (e) {
      yield call(handleError, e, actions.enable);
      if(throwError) {
        throw e;
      }
    }
  },
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.enable.request().type, workers.enableDiscount),
    takeEvery(actions.disable.request().type, workers.disableDiscount),
  ]);
}

export const reducer = createReducer({
  ...entity.reducer,
  [actions.enable.success]: (_, payload) => Object.assign({}, _, {[payload['discount']['url']]: payload['discount']}),
  [actions.disable.success]: (_, payload) => Object.assign({}, _, {[payload['discount']['url']]: payload['discount']}),
}, {});

export default {
  actions,
  workers,
  saga,
  reducer
}